import type { ReactNode } from 'react';
import { useTheme } from './useTheme';
import { SvgArtwork } from './SvgArtwork';
import type { ThemeIconName } from './types';

/** A theme can replace an icon independently; every other icon keeps its default. */
export function ThemeIcon({
  name,
  fallback,
  className,
}: {
  name: ThemeIconName;
  fallback: ReactNode;
  className?: string;
}) {
  const svg = useTheme().seasonPackage.icons?.[name];
  return svg ? <SvgArtwork svg={svg} className={className} /> : <>{fallback}</>;
}
